// extracted by mini-css-extract-plugin
export default {"root":"WAKCY__root"};